import React, { useState, useEffect, useMemo } from "react";
import { Container, Label } from "reactstrap";
import Navbar from "components/Website/Layouts/Header";
import "./style.scss";
import lockImg from "assets/images/lock.png";
import AuthService from "services/Website/AuthService";
import chromeImg from "assets/images/chrome.png";
import loginImg from "assets/images/login.png";
// import faceImg from "assets/images/face.png";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import ErrorMessage from "components/Common/ErrorMessage/ErrorMessage";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginValidator } from "FormValidations/Website/Auth/LoginValidator";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { authenticate, appendFilters } from "store/Auth/actions";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
// import FacebookLogin from "react-facebook-login";
// import GoogleLogin from 'react-google-login';
import { useGoogleLogin } from "@react-oauth/google";
import ProfileService from "../../../services/Client/ProfileService";


const quryParams = ["industry", "size", "website_type", "name", "description", "content", "domain", "template", "plan"];

const Login = ({ history }) => {
  const [paramsObj, setParamsObj] = useState(null);
  // const [rememberMe, setRememberMe] = useState(false);

  let query = useQuery();
  const { industry, size, website_type, name, description, content, domain, template } = paramsObj || {};
  const { register, formState: { errors }, handleSubmit } = useForm({ resolver: yupResolver(loginValidator) });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const data = useSelector(state => state.Auth);
  const UserService = new ProfileService();

  useEffect(() => {
    const updatedParamsObj = {};
    for (let index = 0; index < quryParams.length; index++) {
      updatedParamsObj[`${quryParams[index]}`] = query.get(`${quryParams[index]}`);
    }
    setParamsObj(updatedParamsObj);
  }, []);

  const googleLogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      const { data: res, status: statusCode } = await UserService.getGoogleUserData(codeResponse);
      if (statusCode === 200) {
        const userData = await AuthService.registerSocial({
          social_id: res.id, name: res.name, email: res.email, social_type: "google"
        });
        if (userData && userData.status) {
          dispatch(authenticate({
            token: userData.access_token,
            userType: "user",
            user_name: res.name,
            email: res.email
          }));
          toast.success("Login Successfully");
          setIsSubmitting(false);

          if (data.navigateTo === "checkout") {
            // let type;
            // if (data?.website_type === 0) {
            //   type = 0;
            // } else {
            //   type = data?.type?.value;
            // }
            if(history?.location?.state?.from?.state?.selectedTemplate){
              history.push(`/checkout?template=${data?.selectedTemplate?.id}&plan=${history?.location?.state?.from?.state?.plan?.id}`, {plan: history?.location?.state?.from?.state?.plan, selectedTemplate: history?.location?.state?.from?.state?.selectedTemplate}); //industry=${data?.industry?.value}&website_type=${type}&
              return
            }
            history.push(`/checkout?template=${data?.selectedTemplate?.id}&plan=${history?.location?.state?.plan?.id}`, {plan: history?.location?.state?.plan, selectedTemplate: history?.location?.state.selectedTemplate}); //industry=${data?.industry?.value}&website_type=${type}&&size=${data.size.value}&name=${data.business_name}&description=${data.business_description}&domain=${data.has_domain}&content=${data.has_content}
          } else {
            history.push(`/client/projects`, {
              email: res.email,
              room: "23",
              from: 'login'
            });
          }
        }
      } else {
        toast.error("Google Lgoin Failed");
      }


    }, onError: (error) => console.log("Login Failed:", error)
  });

  useEffect(() => {
    let selectedIndustry, selectedSize, selectedType;
    let { industryOptions, sizeOptions, typeOptions } = data;
    if (industryOptions?.length && sizeOptions?.length && typeOptions?.length && paramsObj) {
      let typeCondition = data?.website_type !== 0 && !data?.type;
      if (!data.industry || !data.size || typeCondition) {
        selectedIndustry = industryOptions?.find(option => option.value == industry);
        selectedSize = sizeOptions?.find(option => option.value == size);
        selectedType = typeOptions?.find(option => option.value == website_type);
        dispatch(appendFilters({
          industry: selectedIndustry,
          size: selectedSize,
          type: parseInt(website_type) === 0 ? null : selectedType,
          website_type: parseInt(website_type) === 0 ? 0 : "",
          business_name: name,
          business_description: description,
          has_domain: parseInt(domain),
          has_content: parseInt(content),
          template,
        }));
      }
    }
  }, [data.industryOptions, data.sizeOptions, data.typeOptions, paramsObj]);


  // const responseFacebook = (response) => {
  //   console.log(response);
  // };


  const handleValidSubmit = async (values) => {
    setIsSubmitting(true);
    let requestData = {
      email: values.email, password: values.password, rememberMe: false
    };
    AuthService.login(requestData).then(res=>{
      if (res && res.status) {
        dispatch(authenticate({
          token: res.access_token, userType: "user", user_name: res.name, email: res.email
        }));
        toast.success("Login Successfully");
        if(data.navigateTo === "checkout") {
          // let type;
          // if (data?.website_type === 0) {
          //   type = 0;
          // } else {
          //   type = data?.type?.value;
          // }

          if(history?.location?.state?.from?.state?.selectedTemplate){
            history.push(`/checkout?template=${data?.selectedTemplate?.id}&plan=${history?.location?.state?.from?.state?.plan?.id}`, {plan: history?.location?.state?.from?.state?.plan, selectedTemplate: history?.location?.state?.from?.state?.selectedTemplate}); //industry=${data?.industry?.value}&website_type=${type}&
            return
          }
          history.push(`/checkout?template=${data?.selectedTemplate?.id}&plan=${history?.location?.state?.plan?.id}`, {plan: history?.location?.state?.plan, selectedTemplate: history?.location?.state.selectedTemplate}); //industry=${data?.industry?.value}&website_type=${type}&size=${data.size.value}&name=${data.business_name}&description=${data.business_description}&domain=${data.has_domain}&content=${data.has_content}
        } else {
          history.push(`/client/projects`, {
            email: values.email, room: "12-12", from: 'login'
          });
        }
      }
      setIsSubmitting(false);
    }).catch(error=> {
        toast.error(error.response.data.error);
        setIsSubmitting(false);
    }) 
  };

  return (<>
    <Helmet>
      <title>Webkicks</title>
      <meta name="description" content="sign in to webkick app"/>
    </Helmet>
    <div className="websitPages cardSign mt-5 pt-3">
      <Navbar/>
      <Container>
        <div className="d-lg-flex pt-5 pb-4">
          <div className="card w-100 p-2">
            <div className="card-body px-lg-4 px-2">
              <h5 className="fw-bold">
                <img src={lockImg} alt="lock" className="pe-2"/> {t("Welcome back!")}
              </h5>
              <p
                className="text-muted ps-4 font-14 pb-2">{t("Enter your login details to access your account.")}</p>
              <hr className="opacity-50 border-bottom"/>
              <div className="px-2 py-2">
                <button className="btn btnSign me-md-3 mb-1" onClick={() => googleLogin()}>
                  <img src={chromeImg}
                       className="pe-3"
                       alt="chrome"/> {t("Login with Google")}
                </button>

                {/* <FacebookLogin
                  appId="943267207026926"
                  fields="name,email,picture"
                  scope="public_profile"
                  cssClass="btnSign"
                  textButton={t("Login with Facebook")}
                  icon={<img src={faceImg} className="pe-3" />}
                  callback={responseFacebook}
                  /> */}

                {/* <button className="btn btnSign mb-1"><img src={faceImg} className="pe-3"
                                                          alt="face"/> {t("Sign in using Facebook")}</button> */}
              </div>
              <hr className="opacity-50 border-bottom"/>
              <form onSubmit={handleSubmit(handleValidSubmit)} className="px-2">
                <div className="mb-3 pt-xl-2">
                  <Label>{t("Email Address")}</Label>
                  <input
                    {...register("email")}
                    type="email"
                    className="form-control btnHeightLg"
                    placeholder="Your email"
                  />
                  {errors?.email && <ErrorMessage message={errors?.email?.message}/>}
                </div>
                <div className="mb-3">
                  <Label>{t("Password")}</Label>
                  <input
                    {...register("password")}
                    type="password"
                    className="form-control btnHeightLg"
                    placeholder="************"
                  />
                  {errors?.password && <ErrorMessage message={errors?.password?.message}/>}
                </div>
                {/* <div>
                      <input id='remember' type='checkbox' value='Remeber me' onChange={() => setRememberMe(!rememberMe)} />
                      <label htmlFor="remember" style={{marginLeft: '8px'}}>Remember me</label>
                  </div> */}
                <div className="mb-1 d-flex justify-content-between pt-1">
                  {/* <Label className="cursor-pointer">
                    <input id="remember" className="me-2" type="checkbox"
                           onChange={() => setRememberMe(!rememberMe)}/>
                    Remember Me
                  </Label> */}
                  <p className="d-none d-sm-flex mb-2">
                    <span className="text-muted me-2">Forgot your password?</span>
                    <Link to="/forget-password">{t("Click here to reset.")}</Link>
                  </p>
                </div>
                <p className="d-flex d-sm-none mb-1">
                  <span className="text-muted me-2">Forgot your password?</span>
                  <Link to="/forget-password">{t("Click here to reset.")}</Link>
                </p>
                <div className="d-xl-flex pt-1">
                  <button
                    className="btn btn-primary mb-0 mt-2 px-4 btnSignClick btnHeightLg"
                    disabled={isSubmitting}
                    type="submit">
                    {t("login")}
                  </button>
                  <div className="pt-3 mt-1 px-md-4 linkSign">
                    <p onClick={() => {
                      if (data.navigateTo === "checkout") {
                        // let type;
                        // if (data?.website_type === 0) {
                        //   type = 0;
                        // } else {
                        //   type = data?.type?.value;
                        // }
                        if(history?.location?.state?.from?.state?.selectedTemplate){
                          history.push(`/register?template=${data?.template}&plan=${history?.location?.state?.from?.state?.plan?.id}`, {selectedTemplate: history?.location?.state?.from?.state?.selectedTemplate}); //industry=${data?.industry?.value}&website_type=${type}&
                          return
                        }

                        history.push(`/register?template=${data.template}&plan=${history?.location?.state?.plan?.id}`, {selectedTemplate: history?.location?.state.selectedTemplate}); //industry=${data.industry.value}&website_type=${type}&&size=${data.size.value}&name=${data.business_name}&description=${data.business_description}&domain=${data.has_domain}&content=${data.has_content}
                      } else {
                        history.push(`/register`);
                      }
                    }} className="text-primary btn-hover">{t("Don't have an account? Create Account")}</p>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="position-relative">
            <img src={loginImg} alt="login" className="imgLogin d-none d-md-block"/>
            <p className="absoluteTextTop text-white d-none d-md-block">“By far one of the best choices I made to use
              Webkicks to launch a website for my business”</p>
            {/* <div className="absoluteTextBottom text-white d-none d-md-block">
              <h5>Sara Dijambwe</h5>
              <p className="opacity-75">Owner at Sara’s Boutique</p>
            </div> */}
          </div>
        </div>
      </Container>
    </div>
  </>);
};

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

Login.propTypes = {
  history: PropTypes.object, match: PropTypes.object
};

export default Login;
